// **  Initial State
const initialState = {
  requestInfo: {
    request_type_title: '',
    tabs: [],
    tabFiles: [],
    initDependency: [],
    dependency: [],
    dependency_req: [],
    dependency_dates: [],
    answers: [],
    active_step: '',
    touched: false,
    allowValidationOnSave: false,
    files: [],
    hiddenFiles: [],
    tabs_preview: []
  },
  requestStatus: {
    can_delete: true,
    can_edit: true,
    can_submit: false,
    status: "not_completed",
    reason: null
  }
}

export const requestReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'REQUEST_SET_ACTIVE_STEP':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          active_step: action.activeStep
        }
      }
    case 'REQUEST_ALLOW_VALIDATION_ANSWERS_ON_SAVE':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          allowValidationOnSave: action.allow
        }
      }
    case 'REQUEST_SET_REQUEST_INFO':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          ...action.data
        }
      }
    case 'REQUEST_SET_REQUEST_TABS_PREVIEW':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          request_type_title: action.data.request_type_title,
          tabs_preview: action.data.request_preview
        }
      }
    case 'REQUEST_SET_REQUEST_INFO_FILES':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          tabFiles: action.data.request_items
        }
      }
    case 'REQUEST_SET_REQUEST_STATUS':
      return {
        ...state,
        requestStatus: {
          ...state.requestStatus,
          ...action.data
        }
      }
    case 'REQUEST_SET_ANSWERS':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          answers: {
            ...state.requestInfo.answers,
            ...{ [action.id]: { ...state.requestInfo.answers[action.id], ...action.answer[action.id] } }
          }
        }
      }
    case 'REQUEST_SET_FILE_ANSWERS':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          files: action.data.request_files
        }
      }
    case 'REQUEST_SET_FILE_ANSWER':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          files: {
            ...state.requestInfo.files,
            ...{ [action.id]: { ...state.requestInfo.files[action.id], ...action.file[action.id] } }
          }
        }
      }
    case 'REQUEST_SET_HIDDEN_FILE_ANSWERS':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          hiddenFiles: {
            ...state.requestInfo.hiddenFiles,
            ...{ [action.id]: { ...state.requestInfo.hiddenFiles[action.id], ...action.hiddenFiles[action.id] } }
          }
        }
      }
    case 'REQUEST_CHANGE_HIDDEN_FILE_ANSWERS':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          hiddenFiles: {
            ...state.requestInfo.hiddenFiles,
            ...{ [action.id]: { ...state.requestInfo.hiddenFiles[action.id], status: action.status } }
          }
        }
      }
    case 'REQUEST_SET_BULK_ANSWERS':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          answers: {
            ...state.requestInfo.answers,
            ...action.answers
          }
        }
      }
    case 'REQUEST_CLEAR_ANSWERS':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          answers: _.keyBy(_.filter(state.requestInfo.answers,
            (answer, index) => {
              const key = answer.level ? `${answer.question_id}:${answer.level}` : answer.question_id
              return key !== action.id
            }), answer => (answer.level ? `${answer.question_id}:${answer.level}` : answer.question_id))
        }
      }
    case 'REQUEST_CLEAR_REQUEST':
      return {
        ...state,
        requestInfo: {
          ...initialState.requestInfo
        }
      }
    case 'REQUEST_SET_DEPENDENCY':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          dependency: {
            ...state.requestInfo.dependency,
            [action.key]: { ..._.get(state.requestInfo.dependency, action.key), ..._.get(action.dependency, action.key) }
          }
        }
      }
    case 'REQUEST_SET_INIT_DEPENDENCY':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          initDependency: {
            ...state.requestInfo.initDependency,
            [action.key]: { ..._.get(state.requestInfo.initDependency, action.key), ..._.get(action.dependency, action.key) }
          }
        }
      }
    case 'REQUEST_CHANGE_DEPENDENCY':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          dependency: action.dependencies
        }
      }
    case 'REQUEST_SET_DEPENDENCY_REQ':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          dependency_req: {
            ...state.requestInfo.dependency_req,
            [action.key]: { ..._.get(state.requestInfo.dependency_req, action.key), ..._.get(action.dependencyReq, action.key) }
          }
        }
      }
    case 'REQUEST_SET_DEPENDENCY_DATE':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          dependency_dates: {
            ...state.requestInfo.dependency_dates,
            ...action.dependency_date
          }
        }
      }
    case 'REQUEST_TOUCHED_ANSWERS':
      return {
        ...state,
        requestInfo: {
          ...state.requestInfo,
          touched: action.touched
        }
      }
    default:
      return state
  }
}
